import { SVGProps } from 'react';

const SearchRangeXIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3.333 3.833 9.778 13.334h3.556L6.889 3.833H3.333ZM3.333 17.167l5.64-5.64m2.05-2.05 5.644-5.644"
    />
  </svg>
);

export default SearchRangeXIcon;
